import { Box, Grid, Typography, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Stack } from "@mui/material";
import React from "react";

const ClassifierBuilderTips = () => {
    const theme = useTheme();
    const tips = [
        "Name your classifier, select the category, and add a description.",
        "Add a group and rule to a classification.",
        "Don't forget to test and publish your classifier.",
    ];
    return (
        <Grid container direction="row">
            {tips.map((tip, idx) => (
                <Grid
                    key={idx}
                    item
                    xs={12}
                    sx={{ padding: theme.spacing(1, 2) }}
                >
                    <Stack direction="row">
                        <InfoOutlinedIcon
                            sx={{
                                marginRight: theme.spacing(1),
                                height: theme.spacing(2.5),
                                width: theme.spacing(2.5),
                                color: "#9CA3AF",
                            }}
                        />
                        <Box>
                            <Typography
                                sx={{
                                    fontSize: theme.typography.h3.fontSize,
                                    fontWeight: 600,
                                }}
                            >{`Tip ${idx + 1}`}</Typography>
                            <Typography>{tip}</Typography>
                        </Box>
                    </Stack>
                </Grid>
            ))}
        </Grid>
    );
};

export default ClassifierBuilderTips;
